<div class="wrapper" [formGroup]="searchFilters">
  @for (option of filterOption; track option) {
    <div class="app-search-header-group-filter">
      <div class="app-search-header-group-filter-label">
        <label class="bold" [attr.aria-label]="option.displayName" style="display:inline;">
          <span>{{option.displayName==='Application ID'?'Quote Number':option.displayName}}</span>
        </label>
      </div>
      @if (option.field_type === 'text') {
        <div>
          <input #input autofocus [id]="option.id" [attr.aria-label]="" [type]="option.field_type"
            [formControlName]="option.code" [minlength]="option.min_length" [maxlength]="option.max_length"
            [pattern]="option.pattern" attr.data-cy="{{option.code}}">
          </div>
        }
        @if (option.field_type === 'dropdown') {
          <div class="app-search-header-group-filter-input">
            <mat-form-field type='dropdown' disableOptionCentering='true'>
              <mat-select hideSingleSelectionIndicator #input type="dropdown" [attr.id]="option.id" [id]="option.id" class="focusInput"
                [formControlName]="option.code" attr.data-cy="{{option.code}}" placeholder="Select">
                @for (choice of option.choices; track choice) {
                  <mat-option [value]="choice">{{ choice }}</mat-option>
                }
              </mat-select>
              <mat-placeholder></mat-placeholder>
            </mat-form-field>
          </div>
        }
      </div>
    }
  </div>
